import React from "react";
import RepDashboard from "./RepDashboard";

function ManagerDashboard() {
  return <RepDashboard />;
}

export default ManagerDashboard;
